import { bridge } from '../../../bridge';
import { getWebBaseURL } from '../../../getWebBaseURL';
import { isNotNil } from '../../../isNotNil';

export const moveToPhotoReviewList = (params: {
  goodsSno: number;
  reviewSno?: number;
  titleBar?: boolean;
}) => {
  const pagePath = `/goods/${params.goodsSno}/reviews/photo/list${isNotNil(params.reviewSno) ? `?review_sno=${params.reviewSno}` : ''}`;

  bridge.openDeeplink(
    `ably://webview?title_bar=${params.titleBar ?? false}&url=${pagePath}`,
    {
      webCallback: async () => {
        const baseURL = await getWebBaseURL();
        location.href = `${baseURL}${pagePath}`;
      },
    },
  );
};
